import initRelayLayer from '../initRelayLayer';

import genericRequest from './RequestGeneric';

// For request to app server via app network layer
export default async function request(relayQuery, params) {
    let RelayNetworkLayer = initRelayLayer();

    return genericRequest(relayQuery, params, RelayNetworkLayer);
}
